import { render, staticRenderFns } from "./ArticleHandler.vue?vue&type=template&id=0f92b3d7&scoped=true"
import script from "./ArticleHandler.vue?vue&type=script&lang=ts"
export * from "./ArticleHandler.vue?vue&type=script&lang=ts"
import style0 from "./ArticleHandler.vue?vue&type=style&index=0&id=0f92b3d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f92b3d7",
  null
  
)

export default component.exports